@if (view$ | async; as view) {
    @if (view.active.length > 0 || view.errors.length > 0) {
        <div class="upload-dock">
            <!-- Uma pílula por erro: fecha no X (o serviço também remove sozinho após 5s) -->
            @for (upload of view.errors; track upload.id) {
                <ra-island class="pill pill--error" animate.enter="pill-enter" animate.leave="pill-leave">
                    <ra-island-ring [color]="'accentRed'">
                        <ra-icon [icon]="'danger'" [size]="14" [varColor]="'accentRed'" />
                    </ra-island-ring>

                    <span class="ra-island-text pill-name">{{ upload.fileName }}</span>
                    <span class="ra-island-meta">{{ upload.error || ('shared.uploadProgressBar.uploadError' | translate) }}</span>

                    <span class="ra-island-divider"></span>
                    <button
                        type="button"
                        class="ra-island-action ra-island-action--icon"
                        [attr.aria-label]="'common.close' | translate"
                        (click)="removeUpload(upload.id)"
                    >
                        <ra-icon [icon]="'close'" [size]="16" [varColor]="'currentColor'" />
                    </button>
                </ra-island>
            }

            <!-- Pílula agregada dos uploads em andamento -->
            @if (view.active.length > 0) {
                @let phase = phaseOf(view.active);
                @let progress = aggregateProgress(view.active);
                @let many = view.active.length > 1;

                <ra-island class="pill" [column]="true" animate.enter="pill-enter" animate.leave="pill-leave">
                    <div class="ra-island-row">
                        <ra-island-ring
                            [progress]="progress"
                            [color]="phase === 'compressing' ? 'alertWarning' : 'primary'"
                        >
                            <ra-icon
                                [icon]="phase === 'saving' ? 'document-upload' : mediaIcon(view.active)"
                                [size]="14"
                                [varColor]="phase === 'compressing' ? 'alertWarning' : 'primary'"
                            />
                        </ra-island-ring>

                        @if (many) {
                            <span class="ra-island-text pill-name">{{ 'shared.uploadProgressBar.filesCount' | translate:{ count: view.active.length } }}</span>
                        }
                        @else {
                            <span class="ra-island-text pill-name">{{ view.active[0].fileName }}</span>
                        }

                        <span class="ra-island-meta">{{ phaseLabelKey(phase) | translate }}</span>

                        <!-- Na gravação o percentual não avança mais: some para a
                             pílula não parecer travada em 100%. -->
                        @if (phase !== 'saving') {
                            <span class="pill-pct">{{ progress }}%</span>
                        }

                        @if (many) {
                            <button
                                type="button"
                                class="ra-island-action ra-island-action--icon pill-toggle"
                                [class.is-open]="expanded()"
                                [attr.aria-expanded]="expanded()"
                                [attr.aria-label]="(expanded()
                                    ? 'shared.uploadProgressBar.hideFiles'
                                    : 'shared.uploadProgressBar.showFiles') | translate"
                                (click)="toggleExpanded()"
                            >
                                <ra-icon [icon]="'arrow-down'" [size]="16" [varColor]="'currentColor'" />
                            </button>
                        }
                    </div>

                    <!-- Lista por arquivo, dentro da mesma superfície -->
                    @if (many && expanded()) {
                        <div class="pill-files">
                            @for (upload of view.active; track upload.id) {
                                <div class="file-row">
                                    <ra-icon [icon]="mediaIcon([upload])" [size]="14" [varColor]="'currentColor'" />
                                    <span class="file-row-name">{{ upload.fileName }}</span>
                                    <span class="file-row-track">
                                        <span
                                            class="file-row-fill"
                                            [class.compressing]="upload.status === 'compressing'"
                                            [style.width.%]="upload.progress"
                                        ></span>
                                    </span>
                                    <span class="file-row-pct">{{ upload.progress }}%</span>
                                </div>
                            }
                        </div>
                    }
                </ra-island>
            }
        </div>
    }
}
